import React from "react";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { confirmPopup, ConfirmPopup } from "primereact/confirmpopup";
import { DataTable } from "primereact/datatable";
import { TaskTemplateInputFromSubgroup } from "../../../../../api/model/airflow-task/task-template/TaskTemplateInfo";
import { renderHeaderInput, renderDeleteButton } from "./TemplateEditorUtils";
import InputGroupedDefinitionsSubFormsListDialog from "./InputGroupedDefinitionsSubFormsListDialog";

type InputGroupedDefinitionsSubFormsListProps = {
  subForms: TaskTemplateInputFromSubgroup[];
  onSubFormsChange: (newSubForms: TaskTemplateInputFromSubgroup[]) => void;
};

const defaultSubForm: TaskTemplateInputFromSubgroup = {
  header: "",
  inputs: [],
};

const InputGroupedDefinitionsSubFormsList: React.FC<InputGroupedDefinitionsSubFormsListProps> = ({
  subForms,
  onSubFormsChange,
}) => {
  const confirmOnDelete = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, index: number) => {
    confirmPopup({
      target: e.currentTarget,
      message: "Are you sure you want to delete this subForm?",
      icon: "pi pi-exclamation-triangle",
      acceptClassName: "p-button-danger",
      accept: () => deleteColumn(index),
    });
  };

  const deleteColumn = (index: number) => {
    const newSubForms = subForms.filter((_, i) => i !== index);
    onSubFormsChange(newSubForms);
  };

  const updateSubFormHeader = (index: number, value: string) => {
    const updatedSubForms = subForms.map((subForm, i) =>
      i === index ? { ...subForm, header: value } : subForm
    );
    onSubFormsChange(updatedSubForms);
  };

  const updateSubFormInputs = (newSubForm: TaskTemplateInputFromSubgroup, index: number) => {
    const updatedSubForms = subForms.map((subForm, i) => (i === index ? newSubForm : subForm));
    onSubFormsChange(updatedSubForms);
  };

  const renderInputsDialog = (
    rowData: TaskTemplateInputFromSubgroup,
    options: any,
    onSubFormChange: (newSubForm: TaskTemplateInputFromSubgroup, index: number) => void
  ) => (
    <InputGroupedDefinitionsSubFormsListDialog
      key={rowData.header + options.rowIndex}
      subForm={rowData}
      index={options.rowIndex}
      onSubFormChange={onSubFormChange}
    />
  );

  return (
    <>
      <ConfirmPopup />
      <DataTable
        value={subForms}
        size="small"
        editMode="row"
        reorderableRows
        onRowReorder={e => onSubFormsChange(e.value)}
      >
        <Column
          field="header"
          header="Form name"
          body={(rowData, options) => renderHeaderInput(rowData, options, updateSubFormHeader)}
        />
        <Column
          field="inputs"
          align="right"
          header="Inputs"
          body={(rowData, options) => renderInputsDialog(rowData, options, updateSubFormInputs)}
        />
        <Column style={{ width: "0" }} body={renderDeleteButton(confirmOnDelete)} />
        <Column rowReorder style={{ width: "3em" }} />
      </DataTable>
      <div className="flex mt-3">
        <Button
          icon="pi pi-plus"
          className="p-button-outlined p-button-rounded p-button-success mt-3 ml-3"
          onClick={() => onSubFormsChange([...subForms, defaultSubForm])}
        />
      </div>
    </>
  );
};

export default InputGroupedDefinitionsSubFormsList;
